/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Label_Enqueue_SuccessInputs */

const vi_lot_label_enqueue_success = /** @type {(inputs: Lot_Label_Enqueue_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gửi tem tới máy in kho`)
};

/**

* @param {Lot_Label_Enqueue_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_label_enqueue_success = /** @type {((inputs?: Lot_Label_Enqueue_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Label_Enqueue_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_label_enqueue_success(inputs)
});